import { render, staticRenderFns } from "./GI_copy.vue?vue&type=template&id=374e4b26&scoped=true"
import script from "./GI_copy.vue?vue&type=script&lang=js"
export * from "./GI_copy.vue?vue&type=script&lang=js"
import style0 from "./GI_copy.vue?vue&type=style&index=0&id=374e4b26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374e4b26",
  null
  
)

export default component.exports